import { dev } from '$app/environment';

export function expect<T>(value: T | undefined | null, message: string): T {
  if (dev && (value === undefined || value === null)) {
    throw new Error(message);
  }

  return value!;
}

export function assert(predicate: boolean, message: string): asserts predicate {
  if (dev && !predicate) {
    throw new Error(message);
  }
}

export function unreachable(val: never): never {
  console.error(val);
  throw new Error(`Reached an unreachable value, you probably have an unexhausted/unhandled enum`);
}

export const isError = (value: unknown): value is Error => value instanceof Error;
